import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4ivwmhbmyd: FaireBrandEntity = {
  token: "b_4ivwmhbmyd",
  type: "brand",
  name: "SpearmintLOVE",
  avatarUrl:
    "https://cdn.faire.com/fastly/afe78fd62271eb4a9965aad021c8c38e353eb73291c81f6de61d585d62856797.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5ee5bf76f02b609db638d9f47733ce70244477547057f26789c5375c61990df8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/afe78fd62271eb4a9965aad021c8c38e353eb73291c81f6de61d585d62856797.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5ee5bf76f02b609db638d9f47733ce70244477547057f26789c5375c61990df8.jpeg",
  location: "Tempe, AZ, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 50,
  isTopShop: true,
  isInsider: true,
  description:
    "As the go-to platform for the latest trends in baby fashion, SpearmintLOVE is the baby shop for all of those special moments in baby's first year of life. New parents can trust why moms, dads, friends, and grandparents consider SpearmintLOVE as the best baby shop.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:25.242Z",
    importedBy: "entity-db-cli",
  },
};
